module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"candidate":"Кандидат","phone":"Телефон","email":"Email","downloadResume":"Скачать резюме"}}')
  delete Component.options._Ctor
}
